import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  ASSESSMENT_AMENDMENT,
  ASSESSMENT_AMENDMENT_ALL,
  ASSESSMENT_AMENDMENT_ALL_UPDATED,
  ASSESSMENT_AMENDMENT_CREATE,
  ASSESSMENT_AMENDMENT_LIST,
  ASSESSMENT_AMENDMENT_PUBLISH,
  ASSESSMENT_MARKS_GENERATE,
  ASSESSMENT_MARK_STATUS,
  ASSESSMENT_ZIP_UPLOADS,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const assessmentMarksSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const assessmentAmendmentSelector = createSelector(assessmentMarksSelector, data => data[ASSESSMENT_AMENDMENT])

export const assessmentMarkStatusSelector = createSelector(
  assessmentMarksSelector,
  data => data[ASSESSMENT_MARK_STATUS]
)

export const assessmentAmendmentAllSelector = createSelector(
  assessmentMarksSelector,
  data => data[ASSESSMENT_AMENDMENT_ALL]
)

export const assessmentAmendmentAllUpdatedSelector = createSelector(
  assessmentMarksSelector,
  data => data[ASSESSMENT_AMENDMENT_ALL_UPDATED]
)

export const assessmentAmendmentListSelector = createSelector(
  assessmentMarksSelector,
  data => data[ASSESSMENT_AMENDMENT_LIST]
)

export const assessmentAmendmentCreateSelector = createSelector(
  assessmentMarksSelector,
  data => data[ASSESSMENT_AMENDMENT_CREATE]
)

export const assessmentAmendmentAmendmentSelector = createSelector(
  assessmentMarksSelector,
  data => data[ASSESSMENT_AMENDMENT_PUBLISH]
)

export const assessmentMarksGenerateSelector = createSelector(
  assessmentMarksSelector,
  data => data[ASSESSMENT_MARKS_GENERATE]
)

export const assessmentZipUploadsSelector = createSelector(
  assessmentMarksSelector,
  data => data[ASSESSMENT_ZIP_UPLOADS]
)
